import { Fact } from '../../common/fact';

require('./facts-slider-view.component.scss');

class FactsSliderViewController {
  constructor($scope, $element) {
    this.$scope = $scope;
    this.isImage = Fact.isImage;
    this.getImageFileName = Fact.getImageFileName;
  }

  get selectedImage() {
    if (!this.selectedFact) return null;
    const fileName = this.getImageFileName(this.selectedFact);
    if (!fileName) return null;
    return '/media/' + fileName;
  }

}

export const FactsSliderViewComponent = {
  bindings  : {
    filter      : '<',
    selectedFact: '<',
  },
  template  : require('./facts-slider-view.component.html'),
  controller: FactsSliderViewController,
};



// WEBPACK FOOTER //
// ./src/facts/slider/facts-slider-view.component.js